import(/* webpackMode: "eager" */ "/home/runner/work/lovingnext/lovingnext/src/app/global-error.tsx");
